import React from 'react';
import block from 'bem-cn-lite';
import i18n from '../../../i18n';
import { I18n } from 'react-i18next';

class CommentInput extends React.Component {
    componentDidMount() {
        this.textArea.focus();
    }

    handleKeyPress = (event) => {
        const value = event.target.value.trim();

        if (event.key === 'Enter') {
            event.preventDefault();

            if (value) {
                this.props.onEnter(value);
            }
        }
    }

    setRef = (ref) => {
        this.textArea = ref;
        this.props.textAreaRef(ref);
    }

    render() {
        const b = block('CommentInput');
        const {avatar} = this.props;
        const commentInputPlaceholder = i18n.t('global:commentPlaceholder');


        return (
            <I18n ns={ ["global"] }>
            {
                (t, { i18n }) => (
                    <div className={b()}>
                    <div className={b('tooltip')}>{t('global:commentTooltip')}</div>
                    <div className={b('avatar')}>
                        <img src={avatar} alt="avatar"/>
                    </div>
                    <textarea
                        ref={this.setRef}
                        className={b('textArea')}
                        onKeyPress={this.handleKeyPress}
                        placeholder={commentInputPlaceholder}>
                        </textarea>
                    <div className={b('cta-text')}>{t('global:pressEnterToSubmit')}</div>
                </div>
                )
            }
            </I18n>
        )
    }
}

export default CommentInput;